var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VueQuillEditor',{ref:"text",attrs:{"content":_vm.content,"options":_vm.editorOption,"template-str":_vm.templateStr},model:{value:(_vm.editContent),callback:function ($$v) {_vm.editContent=$$v},expression:"editContent"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }